var _rect, _path, _rect2, _ellipse, _ellipse2, _ellipse3, _path2, _rect3, _ellipse4, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeStandXlShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 42,
    viewBox: "0 0 205 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 205,
    height: 3,
    fill: "#00AEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82353 37H200.176L205 39H0L4.82353 37Z",
    fill: "#99DFF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 3,
    fill: "#00AEEF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.6706,
    cy: 37.5,
    rx: 8.2,
    ry: 0.5,
    fill: "black",
    fillOpacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.788,
    cy: 37.5,
    rx: 8.2,
    ry: 0.5,
    fill: "black",
    fillOpacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.5235,
    cy: 37.5,
    rx: 8.2,
    ry: 0.5,
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3H205L202.588 5H192.941V4H171.235V5H139.882V4H118.176V5H85.6176V4H63.9118V5H32.5588V4H10.8529V5H2.41176L0 3Z",
    fill: "#008BC0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.61768,
    y: 4,
    width: 2.41176,
    height: 34,
    fill: "#00AEEF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.847,
    cy: 37.5,
    rx: 8.2,
    ry: 0.5,
    fill: "black",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198.97,
    y: 4,
    width: 2.41176,
    height: 34,
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeStandXlShort);
export default __webpack_public_path__ + "static/media/TubeStandXLShort.abd1d0b95a0257a3b4ad9ceff3dc7c49.svg";
export { ForwardRef as ReactComponent };